import React from 'react';
import { render } from 'react-dom';
import * as Sentry from "@sentry/react";
import { WebApp } from "./Everou/WebApp";
import { VersionHelper } from './Everou/_helpers/VersionHelper';
import { SENTRY_DSN } from "./Everou/_constants/url.constants";
import { runDomainMigration } from "./Common/branding/domainMigration";

// Legacy *.baintex.com -> *.ai360access.com session handoff. Must resolve before
// the store hydrates from localStorage (it may write the migrated session first);
// when it triggers an outbound redirect there is nothing to render on this
// (legacy) origin. Fail open: if the handoff errors, still start the app.
runDomainMigration()
    .then(redirecting => { if (!redirecting) startApp(); })
    .catch(() => startApp());

function startApp() {
    if (SENTRY_DSN !== "" && SENTRY_DSN !== "DEFAULT") {
        Sentry.init({
            dsn: SENTRY_DSN,
            release: "everou-webapp@"+ VersionHelper.getAppVersion(),
            integrations: [],
            ignoreErrors: [
                'ResizeObserver loop limit exceeded',
                'ResizeObserver loop completed with undelivered notifications.',
                // injected by a browser extension, not our code
                'extDomain is not defined',
                // a Safari web extension messaging its background page
                'runtime.sendMessage',
            ],
        });
    }

    render(
        // logging every action with the whole state only helps while developing
        <WebApp enableLogger={process.env.NODE_ENV !== "production"} />,
        document.getElementById('app'),
    );
}
